module.exports = __webpack_public_path__ + "static/media/food-entertainment.a0cadc2c.svg";